<script setup>

</script>
<template>
    <div class="w-screen flex flex-col items-center">
        <div>
            <h1 class="mb-4 text-4xl font-extrabold leading-none tracking-tight md:text-5xl lg:text-6xl">Account</h1>
        </div>
    </div>
</template>